/**
 *
 * @author Matthew Rawson @ 12/02/2019 13:47
 * @description
 * @notes
 */
import React, {PureComponent} from "react"

import id from "@irati/utils/id"
import AnalysisContext from "@irati/insights/context/AnalysisContext"

import Analysis from "./Analysis"
import AnalysisEmptyState from "./AnalysisEmptyState"
import {AnonymityCard} from "../AnonymityCard"


const MIN_RESPONSES = 5


class AnalysisResponseCountChecker extends PureComponent {
  render() {
    const idNamespace = id("AnalysisResponseCountChecker", this.props)

    return (
      <AnalysisContext.Consumer>
        {({filters, responseCount}) => {
          /** team restriction mode */
          const isRestrictedMode = filters.teamId && responseCount < MIN_RESPONSES
          if (isRestrictedMode) return <AnonymityCard />

          /** Empty results */
          if (!(responseCount > 0)) return <AnalysisEmptyState />

          /**  Display analysis */
          return <Analysis id={idNamespace} filters={filters} />
        }}
      </AnalysisContext.Consumer>
    )
  }
}

export default AnalysisResponseCountChecker
